import React from 'react'
import './Aboutus.css'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import { Button, CardActionArea, CardActions } from '@mui/material';
import Testimonial from '../Testmonial/Testimonial'
const Aboutus = ({id}) => {
    return (

      <div>
    <Testimonial/>
      </div>
    )
}

export default Aboutus